<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <install-prompt></install-prompt>
          <h2 class="title" style="margin-bottom:30px;" color>
            {{ $t("wheel.mainPage.title") }}
          </h2>
          <base-modal
            :title="modalTitle"
            :message="modalMessage"
            :showModal="showModal"
            @close-modal="showModal = false"
          />
          <div v-if="showWinWheel">
            <win-wheel
              :segments="wheelMembers"
              :startWheel="wheelIsRunning"
              @drawn="wheelStopped"
            />

            <div class="row justify-content-center" style="margin-bottom:10px;">
              <button
                class="btn btn-base btn-fill float-middle"
                @click="startWheel"
                style="margin-top:20px;"
              >
                {{ $t("wheel.mainPage.wheelButton") }}
              </button>
            </div>

            <div style="text-align:center;">
              <a href="#" @click="renameSlots">
                <u style="color:white;">{{
                  $t("wheel.mainPage.renameLink")
                }}</u>
              </a>
            </div>
          </div>

          <div v-else>
            <div v-for="item in wheelOptions" v-bind:key="item.id">
              <base-input
                type="text"
                :label="$t('wheel.renamePage.inputLabel')"
                :placeholder="$t('wheel.renamePage.inputPlaceholder')"
                :addonRightRemoveID="wheelOptions.length > 1 ? item.id : null"
                v-model="item.text"
                @remove-input="removeWheelInput"
              ></base-input>
            </div>
            <div>
              <button
                type="submit"
                class="btn btn-base btn-fill float-right"
                @click="showWinWheel = !showWinWheel"
              >
                {{ $t("wheel.renamePage.saveButton") }}
              </button>
            </div>
          </div>
          <br />

          <div slot="footer" style="width:100%">
            <share-footer />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mixin } from "src/mixin";

import WinWheel from "src/components/WinWheel/WinWheel.vue";
import ShareFooter from "src/components/ShareFooter.vue";

export default {
  mixins: [mixin],

  components: {
    WinWheel,
    ShareFooter,
  },

  data() {
    return {
      wheelMembers: [],
      wheelOptions: [
        {
          id: 1,
          text: this.$t("wheel.mainPage.firstSlot"),
        },
        {
          id: 2,
          text: this.$t("wheel.mainPage.secondSlot"),
        },
        {
          id: 3,
          text: this.$t("wheel.mainPage.thirdSlot"),
        },
        {
          id: 4,
          text: this.$t("wheel.mainPage.fourthSlot"),
        },
        {
          id: 5,
          text: this.$t("wheel.mainPage.fifthSlot"),
        },
        {
          id: 6,
          text: this.$t("wheel.mainPage.sixthSlot"),
        },
        {
          id: 7,
          text: this.$t("wheel.mainPage.seventhSlot"),
        },
        {
          id: 8,
          text: this.$t("wheel.mainPage.eighthSlot"),
        },
        {
          id: 9,
          text: "",
        },
      ],
      wheelMaxNumber: 10,
      showWinWheel: true,
      wheelIsRunning: false,
    };
  },
  watch: {
    wheelOptions: {
      deep: true,
      handler(wheelOptions) {
        if (!this.showWinWheel) {
          // Add new element if the last element was setted
          const lastElement = wheelOptions[wheelOptions.length - 1];
          if (
            lastElement.text !== "" &&
            wheelOptions.length < this.wheelMaxNumber
          ) {
            wheelOptions.push({ id: wheelOptions.length + 1, text: "" });
          }
        }
      },
    },
    showWinWheel: {
      immediate: true,
      handler(value) {
        if (value) {
          this.wheelMembers = this.wheelOptions.map((wheelOption) => {
            return {
              id: wheelOption.id,
              text: this.replaceSpaces(wheelOption.text),
              textFillStyle: "#fff",
              fillStyle: wheelOption.id % 2 ? "#000" : "red",
            };
          });
          if (!this.wheelMembers[this.wheelMembers.length - 1].text)
            this.wheelMembers.pop();
        }
      },
    },
  },

  created() {
    this.enableLotteryCheck();
  },

  beforeDestroy() {
    this.disableLotteryCheck();
  },

  methods: {
    replaceSpaces(string) {
      const array = Array.from(string);
      var counter = 0;
      const newArray = array.map((char) => {
        counter = counter + 1;
        if (counter >= 8 && char === " ") {
          counter = 0;
          return "\n";
        } else return char;
      });
      return newArray.join("");
    },

    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return "col-md-3 col-md-offset-1";
      } else if (remainder === 2) {
        return "col-md-4";
      } else {
        return "col-md-3";
      }
    },
    removeWheelInput(wheelOptionID) {
      this.wheelOptions.splice(wheelOptionID - 1, 1);
    },
    startWheel() {
      this.wheelIsRunning = true;
    },
    wheelStopped() {
      this.wheelIsRunning = false;
    },
    renameSlots() {
      this.wheelIsRunning = false;
      this.showWinWheel = !this.showWinWheel;
    },
  },
};
</script>

<style>
.title {
  text-align: center;
}
.description {
  text-align: left;
}
</style>
